module.exports = __webpack_public_path__ + "static/media/hero_video.fd102f3a.webm";